import React from 'react';
import { withRouter } from 'react-router-dom';
import { PrimaryButton } from '../../Components';
import { routes } from '../../routes';
import { translate } from './translate';

export const PrimaryNewOrderButton = withRouter(({ history }) => {
  const routeToOrderCreation = () => history.push(routes.orderCustomerSelection);
  return (
    <PrimaryButton
      onClick={routeToOrderCreation}
      text={translate('newOrder')}
    />
  );
});
